import React from 'react';
import { useNavigate } from 'react-router-dom';

const GEMINI_URL = 'https://gemini.google.com/app';
const NOTEBOOKLM_URL = 'https://notebooklm.google.com/';
const CHATGPT_URL = 'https://chatgpt.com/';

export const trainingMetadataEwhaGeumranAI2026 = {
  id: 'ewha-geumran-middle-ai-2026',
  title: '이화금란중학교 AI 업무 간소화 연수',
  date: '2026-06-15',
  path: '/teacher-training/digital/EwhaGeumranMiddleSchoolAITraining2026',
};

const infoBoxStyle: React.CSSProperties = {
  backgroundColor: 'var(--Color-background-normal)',
  border: '1px solid var(--Color-line-normal)',
  borderRadius: '12px',
  padding: '16px',
  marginBottom: '16px',
};

const tableStyle: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '14px',
  marginTop: '12px',
};

const thStyle: React.CSSProperties = {
  border: '1px solid var(--Color-line-normal)',
  padding: '10px 12px',
  backgroundColor: 'var(--Color-background-main)',
  textAlign: 'left',
  fontWeight: 600,
  color: 'var(--Color-text-strong)',
};

const tdStyle: React.CSSProperties = {
  border: '1px solid var(--Color-line-normal)',
  padding: '10px 12px',
  color: 'var(--Color-text-normal)',
  lineHeight: 1.6,
  verticalAlign: 'top',
};

const codeBlockStyle: React.CSSProperties = {
  margin: '12px 0 0 0',
  padding: '14px 16px',
  backgroundColor: 'var(--Color-background-main)',
  border: '1px solid var(--Color-line-normal)',
  borderRadius: '8px',
  fontSize: '13px',
  lineHeight: 1.7,
  color: 'var(--Color-text-normal)',
  whiteSpace: 'pre-wrap',
  fontFamily: 'Consolas, "Courier New", monospace',
  overflowX: 'auto',
};

const h2Style: React.CSSProperties = {
  fontWeight: 700,
  marginBottom: '12px',
  fontSize: '1.35rem',
  color: 'var(--Color-text-strong)',
};

const bodyTextStyle: React.CSSProperties = {
  color: 'var(--Color-text-normal)',
  marginBottom: '12px',
  lineHeight: 1.7,
  fontSize: '15px',
};

const EwhaGeumranMiddleSchoolAITraining2026: React.FC = () => {
  const navigate = useNavigate();

  const linkButton = (href: string, label: string) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-block',
        marginTop: '8px',
        marginRight: '8px',
        padding: '10px 18px',
        backgroundColor: 'var(--Color-fill-brand-color)',
        color: 'var(--Color-text-inverse)',
        textDecoration: 'none',
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '14px',
        fontFamily: 'var(--font-family-primary)',
      }}
    >
      {label} →
    </a>
  );

  const tocItems: [string, string][] = [
    ['#연수-개요', '연수 개요'],
    ['#사용-도구', '사용 도구 바로가기'],
    ['#전체-흐름', '전체 흐름'],
    ['#순서-1', '1. 오프닝 — AI는 업무 환경'],
    ['#순서-2', '2. 토큰 경제'],
    ['#순서-3', '3. Gemini와 GPT'],
    ['#순서-4', '4. 학교 문서 프롬프트 6요소'],
    ['#순서-5', '5. 역할 설정과 기본 템플릿'],
    ['#순서-6', '6. 실습 1 — 공개수업 가정통신문'],
    ['#순서-7', '7. 실습 2 — 문서 형식 변환'],
    ['#순서-8', '8. 학교 업무별 활용 패턴'],
    ['#순서-9', '9. 사례 — 이수증 확인'],
    ['#순서-10', '10. 업무 자동화 설계'],
    ['#순서-11', '11. GPTs/Gems 업무 도우미'],
    ['#순서-12', '12. 주의사항'],
    ['#정리', '정리'],
  ];

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100%',
        boxSizing: 'border-box',
        padding: '24px',
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        fontFamily: 'var(--font-family-primary)',
        backgroundColor: 'var(--Color-background-main)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <button
          type="button"
          onClick={() => navigate('/teacher-training/training-pages')}
          style={{
            padding: '8px 16px',
            backgroundColor: 'var(--Color-fill-normal)',
            color: 'var(--Color-text-inverse)',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          ← 돌아가기
        </button>
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: 700,
            margin: 0,
            color: 'var(--Color-text-strong)',
            lineHeight: 1.4,
          }}
        >
          {trainingMetadataEwhaGeumranAI2026.title}
        </h1>
      </div>

      <div
        style={{
          marginBottom: '24px',
          border: '1px solid var(--Color-line-normal)',
          padding: '16px',
          borderRadius: '12px',
          backgroundColor: 'var(--Color-background-normal)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}
      >
        <h2 style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.125rem', color: 'var(--Color-text-strong)' }}>
          목차
        </h2>
        <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
          {tocItems.map(([hash, label]) => (
            <li key={hash} style={{ marginBottom: '8px' }}>
              <a
                href={hash}
                style={{
                  textDecoration: 'none',
                  color: 'var(--Color-fill-brand-color)',
                  fontWeight: 500,
                  fontSize: '15px',
                }}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <h2 id="연수-개요" style={h2Style}>
        연수 개요
      </h2>
      <div style={{ ...infoBoxStyle, marginBottom: '20px' }}>
        <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          주제: AI로 학교 업무 간소화하기 — Gemini·GPT 기반 가정통신문·안내문 작성 실습
        </p>
        <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          대상: 이화금란중학교 교직원
        </p>
        <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          일시: 2026년 6월 15일
        </p>
        <p style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          강사: 한지호 · 서부교육지원청
        </p>
      </div>

      <p style={bodyTextStyle}>
        오늘의 목표는 <strong>초안 작성 시간을 줄이고 검토에 집중</strong>하는 것입니다. 단순 사용법보다
        &ldquo;반복 업무를 줄이는 구조&rdquo;를 경험합니다.
      </p>
      <ul style={{ ...bodyTextStyle, marginBottom: '28px', paddingLeft: '22px' }}>
        <li>문서 초안 빠르게 만들기</li>
        <li>같은 내용을 여러 형식으로 변환</li>
        <li>이수증·공문·회의록 정리</li>
        <li>반복 업무를 업무 도우미로 설계</li>
      </ul>

      <h2 id="사용-도구" style={h2Style}>
        사용 도구 바로가기
      </h2>
      <p style={bodyTextStyle}>
        오늘 실습에서 사용하는 AI 도구입니다. 학교·교육청 계정 정책에 맞는 서비스로 접속해 주세요.
      </p>
      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>
          {linkButton(GEMINI_URL, 'Google Gemini')}
          {linkButton(NOTEBOOKLM_URL, 'NotebookLM')}
          {linkButton(CHATGPT_URL, 'ChatGPT')}
        </div>
        <ul
          style={{
            margin: '16px 0 0 0',
            paddingLeft: '20px',
            lineHeight: 1.8,
            color: 'var(--Color-text-normal)',
            fontSize: '14px',
          }}
        >
          <li>
            <strong>Gemini</strong> — 가정통신문·안내문 초안, Google 문서·Drive 연계
          </li>
          <li>
            <strong>NotebookLM</strong> — 공문·자료 요약, 여러 문서 기반 질의
          </li>
          <li>
            <strong>ChatGPT</strong> — 문체 다듬기, 형식 변환, GPTs 업무 도우미
          </li>
        </ul>
      </div>

      <h2 id="전체-흐름" style={h2Style}>
        전체 흐름
      </h2>
      <p style={bodyTextStyle}>프롬프트 실습에서 업무 설계까지 이어지는 100분 연수 흐름입니다.</p>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={thStyle}>시간</th>
            <th style={thStyle}>파트</th>
            <th style={thStyle}>핵심 활동</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>0–10분</td>
            <td style={tdStyle}>오프닝</td>
            <td style={tdStyle}>AI는 도구를 넘어 업무 환경으로</td>
          </tr>
          <tr>
            <td style={tdStyle}>10–35분</td>
            <td style={tdStyle}>기본기</td>
            <td style={tdStyle}>Gemini/GPT 활용 관점 + 학교 문서 프롬프트 6요소</td>
          </tr>
          <tr>
            <td style={tdStyle}>35–70분</td>
            <td style={tdStyle}>실습</td>
            <td style={tdStyle}>가정통신문 작성 → 문자·멘트·체크리스트 변환</td>
          </tr>
          <tr>
            <td style={tdStyle}>70–90분</td>
            <td style={tdStyle}>확장</td>
            <td style={tdStyle}>이수증·공문·회의록 사례 + 업무 자동화 설계</td>
          </tr>
          <tr>
            <td style={tdStyle}>90–100분</td>
            <td style={tdStyle}>정리</td>
            <td style={tdStyle}>GPTs/Gems 활용과 개인정보·최종 검토 원칙</td>
          </tr>
        </tbody>
      </table>

      <h2 id="순서-1" style={h2Style}>
        1. 오프닝 — AI는 업무 환경
      </h2>
      <p style={bodyTextStyle}>
        요즘 AI 트렌드를 학교 업무와 연결해서 봅니다. 오늘의 연결 문장은 다음과 같습니다.
      </p>
      <div style={{ ...infoBoxStyle, marginBottom: '16px', borderColor: 'var(--Color-fill-brand-color)' }}>
        <p style={{ margin: 0, fontSize: '15px', color: 'var(--Color-text-strong)', lineHeight: 1.7, fontWeight: 600 }}>
          &ldquo;AI가 업무 흐름 안으로 들어온다면, 교사는 반복 업무를 어떻게 재설계할 수 있을까?&rdquo;
        </p>
      </div>

      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '17px', color: 'var(--Color-text-strong)' }}>현실 공간</h3>
        <p style={{ margin: 0, ...bodyTextStyle, marginBottom: 0 }}>
          로봇·모빌리티처럼 AI가 화면 밖으로 확장되고 있습니다.
        </p>
      </div>
      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '17px', color: 'var(--Color-text-strong)' }}>기기·OS</h3>
        <p style={{ margin: 0, ...bodyTextStyle, marginBottom: 0 }}>
          Android·WWDC: AI가 운영체제와 단축어 안으로 들어옵니다.
        </p>
      </div>
      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '17px', color: 'var(--Color-text-strong)' }}>문서 업무</h3>
        <p style={{ margin: 0, ...bodyTextStyle, marginBottom: 0 }}>
          HWPX 등 학교 문서도 AI와 연결되는 기반이 됩니다.
        </p>
      </div>
      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '17px', color: 'var(--Color-text-strong)' }}>토큰 경제</h3>
        <p style={{ margin: 0, ...bodyTextStyle, marginBottom: 0 }}>
          많이 넣기보다 필요한 맥락만 정확히 주는 것이 중요합니다.
        </p>
      </div>

      <h2 id="순서-2" style={h2Style}>
        2. 토큰 경제 — 길게 쓰기보다 정확하게 쓰기
      </h2>
      <p style={bodyTextStyle}>
        토큰은 AI가 읽고 쓰는 최소 단위입니다. AI를 잘 쓰는 사람은 프롬프트를 길게 쓰는 사람이 아니라,{' '}
        <strong>필요한 맥락을 선별하는 사람</strong>입니다.
      </p>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={thStyle}>비효율적인 사용</th>
            <th style={thStyle}>효율적인 사용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>불필요한 배경 설명을 길게 입력</td>
            <td style={tdStyle}>역할·목적·대상·형식을 짧게 지정</td>
          </tr>
          <tr>
            <td style={tdStyle}>매번 같은 조건을 반복 입력</td>
            <td style={tdStyle}>반복 조건은 템플릿화</td>
          </tr>
          <tr>
            <td style={tdStyle}>원하는 형식이 불명확함</td>
            <td style={tdStyle}>필요한 항목만 추출 요청</td>
          </tr>
          <tr>
            <td style={tdStyle}>자료 전체를 무조건 붙여넣음</td>
            <td style={tdStyle}>확인 필요는 추측하지 않게 설정</td>
          </tr>
        </tbody>
      </table>

      <h2 id="순서-3" style={h2Style}>
        3. Gemini와 GPT — 학교 업무 관점
      </h2>
      <p style={bodyTextStyle}>
        비교보다 중요한 것은 &ldquo;업무 상황을 구조화하는 방식&rdquo;입니다. 오늘의 기준은 &ldquo;어떤 AI가 더
        좋은가?&rdquo;보다 <strong>&ldquo;어떤 정보를 어떻게 넣을 것인가?&rdquo;</strong>입니다.
      </p>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={thStyle}>상황</th>
            <th style={thStyle}>Gemini</th>
            <th style={thStyle}>GPT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>Google 문서·Drive·Gmail 연계</td>
            <td style={tdStyle}>강점</td>
            <td style={tdStyle}>환경에 따라 활용</td>
          </tr>
          <tr>
            <td style={tdStyle}>가정통신문·안내문 초안</td>
            <td style={tdStyle}>가능</td>
            <td style={tdStyle}>가능</td>
          </tr>
          <tr>
            <td style={tdStyle}>문체 변환·표현 다듬기</td>
            <td style={tdStyle}>가능</td>
            <td style={tdStyle}>강점</td>
          </tr>
          <tr>
            <td style={tdStyle}>PDF·이미지 기반 요약</td>
            <td style={tdStyle}>가능 여부 확인</td>
            <td style={tdStyle}>가능 여부 확인</td>
          </tr>
          <tr>
            <td style={tdStyle}>학교 계정·보안</td>
            <td style={tdStyle} colSpan={2}>
              학교/교육청 정책 확인
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ ...infoBoxStyle, marginBottom: '32px', border: '1px dashed var(--Color-line-normal)' }}>
        <p style={{ margin: '0 0 8px 0', fontSize: '14px', color: 'var(--Color-text-normal)', lineHeight: 1.6 }}>
          실습 시 아래 도구로 바로 이동하세요.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {linkButton(GEMINI_URL, 'Gemini')}
          {linkButton(NOTEBOOKLM_URL, 'NotebookLM')}
          {linkButton(CHATGPT_URL, 'ChatGPT')}
        </div>
      </div>

      <h2 id="순서-4" style={h2Style}>
        4. 학교 문서 프롬프트 6요소
      </h2>
      <p style={bodyTextStyle}>가정통신문·안내문 작성의 기본 구조입니다.</p>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={{ ...thStyle, width: '80px' }}>번호</th>
            <th style={thStyle}>요소</th>
            <th style={thStyle}>질문</th>
          </tr>
        </thead>
        <tbody>
          {[
            ['1', '역할', '누구의 입장에서?'],
            ['2', '목적', '왜 쓰는 문서인가?'],
            ['3', '대상', '누구에게 보내는가?'],
            ['4', '핵심 정보', '일시·장소·대상·내용'],
            ['5', '문체', '공손하고 명확하게'],
            ['6', '형식', '제목·본문·표·유의사항'],
          ].map(([num, label, question]) => (
            <tr key={num}>
              <td style={tdStyle}>{num}</td>
              <td style={tdStyle}>
                <strong>{label}</strong>
              </td>
              <td style={tdStyle}>{question}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 id="순서-5" style={h2Style}>
        5. 역할 설정과 기본 템플릿
      </h2>
      <p style={bodyTextStyle}>
        &ldquo;너는 ~~야&rdquo;는 AI에게 인격을 주는 말이 아니라, <strong>관점과 문체를 정하는 장치</strong>입니다.
        핵심은 역할·대상·문체를 먼저 고정하는 것입니다.
      </p>

      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>덜 공식적인 표현</h3>
        <pre style={codeBlockStyle}>
          {`너는 중학교 담임교사야.
학부모 가정통신문을 작성해줘.`}
        </pre>
      </div>

      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>업무용 표현 (권장)</h3>
        <pre style={codeBlockStyle}>
          {`중학교 담임교사의 입장에서
학부모 대상 가정통신문 형식으로 작성해줘.`}
        </pre>
      </div>

      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>
          기본 프롬프트 템플릿 (복사해서 사용)
        </h3>
        <pre style={codeBlockStyle}>
          {`중학교 [담임/업무 담당]교사의 입장에서 [대상]에게 보낼 [문서 종류]를 작성해줘.

목적: [문서 작성 목적]
핵심 정보: 일시 / 장소 / 대상 / 주요 내용 / 준비물 / 유의사항 / 문의
문체: 공손하고 명확한 학교 안내문 문체, 과장 없이 간결하게
형식: 제목, 안내 본문, 표, 유의사항, 문의 문구`}
        </pre>
      </div>

      <h2 id="순서-6" style={h2Style}>
        6. 실습 1 — 공개수업 가정통신문 만들기
      </h2>
      <p style={bodyTextStyle}>6요소를 채워 넣고 초안을 생성합니다.</p>
      <table style={{ ...tableStyle, marginBottom: '16px' }}>
        <thead>
          <tr>
            <th style={thStyle}>요소</th>
            <th style={thStyle}>입력 내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>
              <strong>역할</strong>
            </td>
            <td style={tdStyle}>중학교 교무기획부 업무 담당교사</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>목적</strong>
            </td>
            <td style={tdStyle}>학교 전체 공개수업 안내</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>대상</strong>
            </td>
            <td style={tdStyle}>전체 학부모</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>핵심 정보</strong>
            </td>
            <td style={tdStyle}>2026.6.15.(월) 14:00~15:00 / 각 학급 교실 및 특별실</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>유의사항</strong>
            </td>
            <td style={tdStyle}>촬영 자제, 참관 후 조용히 이동, 주차 공간 협소</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>형식</strong>
            </td>
            <td style={tdStyle}>제목, 안내 본문, 일정표, 유의사항, 문의 문구</td>
          </tr>
        </tbody>
      </table>

      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>
          후속 프롬프트로 문서 품질 올리기
        </h3>
        <p style={{ margin: '0 0 12px 0', fontSize: '14px', color: 'var(--Color-text-normal)', lineHeight: 1.6 }}>
          처음부터 완벽하게 쓰기보다, 후속 질문으로 다듭니다. AI 문서 작성은 &ldquo;한 번에 끝&rdquo;이 아니라{' '}
          <strong>초안 → 다듬기 → 검토 → 변환</strong>의 흐름입니다.
        </p>
        <ol style={{ margin: 0, paddingLeft: '20px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
          <li>더 간결하고 자연스러운 학교 안내문 문체로 다듬어줘.</li>
          <li>일시, 장소, 대상, 유의사항이 한눈에 보이도록 표를 추가해줘.</li>
          <li>학부모가 오해할 수 있는 표현이 있는지 검토하고 수정해줘.</li>
          <li>최종 배포 전 확인해야 할 체크리스트를 만들어줘.</li>
        </ol>
      </div>

      <h2 id="순서-7" style={h2Style}>
        7. 실습 2 — 하나의 문서를 여러 업무 형태로 변환
      </h2>
      <p style={bodyTextStyle}>
        업무경감의 체감 포인트는 &ldquo;재작성&rdquo;이 아니라 <strong>&ldquo;변환&rdquo;</strong>입니다. 한 번 정리한
        정보를 대상·목적·매체에 맞게 바꿔 쓰는 것이 핵심입니다.
      </p>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={thStyle}>변환 형태</th>
            <th style={thStyle}>요청 예시</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>
              <strong>학부모 문자</strong>
            </td>
            <td style={tdStyle}>5줄 이내, 일시·장소·유의사항 포함</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>학생 안내</strong>
            </td>
            <td style={tdStyle}>종례 시간에 말하듯이 이해하기 쉬운 표현</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>교사용 체크</strong>
            </td>
            <td style={tdStyle}>행사 전·중·후 확인 항목 정리</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>홈페이지 글</strong>
            </td>
            <td style={tdStyle}>제목과 본문, 외부 공개용 정리</td>
          </tr>
        </tbody>
      </table>

      <h2 id="순서-8" style={h2Style}>
        8. 학교 업무별 AI 활용 패턴
      </h2>
      <p style={bodyTextStyle}>가정통신문 실습에서 배운 구조는 다른 업무에도 확장됩니다.</p>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={thStyle}>패턴</th>
            <th style={thStyle}>학교 업무 예시</th>
            <th style={thStyle}>AI 활용 방식</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>초안 작성</td>
            <td style={tdStyle}>가정통신문, 안내문, 동의서</td>
            <td style={tdStyle}>핵심 정보 → 문서 초안</td>
          </tr>
          <tr>
            <td style={tdStyle}>요약 변환</td>
            <td style={tdStyle}>공문, 계획서, 안내문</td>
            <td style={tdStyle}>긴 문서 → 문자·공지</td>
          </tr>
          <tr>
            <td style={tdStyle}>체크리스트화</td>
            <td style={tdStyle}>행사, 체험학습, 공개수업 계획</td>
            <td style={tdStyle}>계획 → 준비사항 목록</td>
          </tr>
          <tr>
            <td style={tdStyle}>구조화</td>
            <td style={tdStyle}>회의 메모, 협의 내용</td>
            <td style={tdStyle}>논의사항·결정사항·할 일 추출</td>
          </tr>
          <tr>
            <td style={tdStyle}>이수증·확인서</td>
            <td style={tdStyle}>이수증, 확인서, 신청서</td>
            <td style={tdStyle}>문서 → 필요한 항목 표 정리</td>
          </tr>
          <tr>
            <td style={tdStyle}>문체 조정</td>
            <td style={tdStyle}>학부모 문자, 생활지도 안내</td>
            <td style={tdStyle}>민감 표현을 중립적 문장으로</td>
          </tr>
        </tbody>
      </table>

      <h2 id="순서-9" style={h2Style}>
        9. 사례 — 이수증 확인 정리
      </h2>
      <p style={bodyTextStyle}>
        이수증만 올리면 &ldquo;누가 어떤 연수를 들었는지&rdquo; 1차 정리합니다. AI는 이수 인정 여부를 판단하지 않고,{' '}
        <strong>문서 정보를 1차 정리</strong>합니다.
      </p>

      <table style={{ ...tableStyle, marginBottom: '16px' }}>
        <thead>
          <tr>
            <th style={thStyle}>Before</th>
            <th style={thStyle}>After</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>
              <ul style={{ margin: 0, paddingLeft: '18px' }}>
                <li>이수증 파일 하나씩 열기</li>
                <li>연수명·기관·시간 확인</li>
                <li>엑셀에 수기 입력</li>
                <li>누락 여부 다시 확인</li>
              </ul>
            </td>
            <td style={tdStyle}>
              <ul style={{ margin: 0, paddingLeft: '18px' }}>
                <li>PDF/이미지 업로드</li>
                <li>AI가 핵심 항목 추출</li>
                <li>표로 정리하고 확인 필요 표시</li>
                <li>담당자는 최종 검토만</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>
          이수증 정리 프롬프트 (복사해서 사용)
        </h3>
        <pre style={codeBlockStyle}>
          {`첨부한 여러 개의 연수 이수증을 확인해서 사람별 이수 내역을 표로 정리해줘.

항목: 번호 / 성명 / 연수명 / 연수기관 / 이수기간 / 이수시간 / 발급일 / 비고

기준:
- 이수증 1개당 표 1행으로 정리
- 문서에 없는 정보는 "확인 필요"
- 글자가 흐리면 "원본 확인 필요"
- 마지막에 담당자가 확인해야 할 항목도 따로 정리`}
        </pre>
      </div>

      <h2 id="순서-10" style={h2Style}>
        10. 업무 자동화 설계
      </h2>
      <p style={bodyTextStyle}>
        AI 업무 자동화는 프롬프트 하나가 아니라 <strong>업무 흐름 설계</strong>입니다. 자동화에서 중요한 것은
        &ldquo;채팅창 결과&rdquo;가 아니라, <strong>다시 확인 가능한 업무 흐름</strong>입니다.
      </p>

      <table style={{ ...tableStyle, marginBottom: '16px' }}>
        <thead>
          <tr>
            <th style={thStyle}>설계 항목</th>
            <th style={thStyle}>질문</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>
              <strong>목적</strong>
            </td>
            <td style={tdStyle}>무엇을 줄일까? 제출 확인? 이수시간 정리? 보고 자료?</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>입력</strong>
            </td>
            <td style={tdStyle}>이수증은 어디로 받을까? Form, Drive, 서버, 이메일?</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>저장</strong>
            </td>
            <td style={tdStyle}>원본과 추출 결과는 어디에 보관할까?</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>추출</strong>
            </td>
            <td style={tdStyle}>AI가 어떤 항목을 읽어야 할까?</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>화면/UI</strong>
            </td>
            <td style={tdStyle}>담당자가 어떤 상태와 결과를 봐야 할까?</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              <strong>검토</strong>
            </td>
            <td style={tdStyle}>AI와 사람이 각각 어디까지 담당할까?</td>
          </tr>
        </tbody>
      </table>

      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>
          이수증 수합 시스템 예시 구조
        </h3>
        <p style={{ margin: 0, fontSize: '15px', color: 'var(--Color-text-normal)', lineHeight: 1.8 }}>
          <strong>입력</strong> Google Form 파일 업로드 → <strong>저장</strong> Drive 원본 폴더(처리완료/확인필요) →{' '}
          <strong>추출</strong> AI가 성명·연수명·기관·시간 읽기 → <strong>화면</strong> Sheets 표 + 상태·원본 링크 →{' '}
          <strong>검토</strong> 담당자 최종 확인·오류 수정
        </p>
      </div>

      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>
          담당자 화면에 보여야 할 것
        </h3>
        <p style={{ margin: '0 0 12px 0', fontSize: '14px', color: 'var(--Color-text-normal)', lineHeight: 1.6 }}>
          UI는 &ldquo;결과를 예쁘게 보여주는 것&rdquo;보다 &ldquo;확인하기 쉽게 만드는 것&rdquo;입니다.
        </p>
        <table style={{ ...tableStyle, marginTop: 0 }}>
          <thead>
            <tr>
              <th style={thStyle}>성명</th>
              <th style={thStyle}>연수명</th>
              <th style={thStyle}>시간</th>
              <th style={thStyle}>상태</th>
              <th style={thStyle}>원본</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={tdStyle}>김○○</td>
              <td style={tdStyle}>생성형 AI 활용 직무연수</td>
              <td style={tdStyle}>15</td>
              <td style={tdStyle}>확인 완료</td>
              <td style={tdStyle}>파일 보기</td>
            </tr>
            <tr>
              <td style={tdStyle}>이○○</td>
              <td style={tdStyle}>디지털 수업 설계 연수</td>
              <td style={tdStyle}>확인 필요</td>
              <td style={tdStyle}>원본 확인 필요</td>
              <td style={tdStyle}>파일 보기</td>
            </tr>
            <tr>
              <td style={tdStyle}>박○○</td>
              <td style={tdStyle}>학교생활기록부 기재 연수</td>
              <td style={tdStyle}>6</td>
              <td style={tdStyle}>확인 완료</td>
              <td style={tdStyle}>파일 보기</td>
            </tr>
          </tbody>
        </table>
        <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: 'var(--Color-text-normal)', lineHeight: 1.6 }}>
          총 제출 16명 · 확인 완료 13건 · 확인 필요 3건 · 미제출 2명
        </p>
      </div>

      <h2 id="순서-11" style={h2Style}>
        11. GPTs/Gems — 반복 업무를 업무 도우미로 저장
      </h2>
      <p style={bodyTextStyle}>
        반복 업무는 저장해두면 더 줄어듭니다. 토큰 절약 포인트: 자주 쓰는 역할·문체·출력 형식을 매번 쓰지 않고
        저장해둡니다.
      </p>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={thStyle}>업무 도우미</th>
            <th style={thStyle}>입력</th>
            <th style={thStyle}>출력</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>가정통신문 작성 도우미</td>
            <td style={tdStyle}>행사 정보</td>
            <td style={tdStyle}>가정통신문·문자·체크리스트</td>
          </tr>
          <tr>
            <td style={tdStyle}>이수증 확인 도우미</td>
            <td style={tdStyle}>PDF/이미지 이수증</td>
            <td style={tdStyle}>연수명·기관·시간 정리표</td>
          </tr>
          <tr>
            <td style={tdStyle}>공문 요약 도우미</td>
            <td style={tdStyle}>공문·붙임자료</td>
            <td style={tdStyle}>해야 할 일·기한·제출처</td>
          </tr>
          <tr>
            <td style={tdStyle}>생활지도 문구 도우미</td>
            <td style={tdStyle}>상황 메모</td>
            <td style={tdStyle}>중립적 학부모 소통 문구</td>
          </tr>
        </tbody>
      </table>

      <h2 id="순서-12" style={h2Style}>
        12. AI 업무 활용 주의사항
      </h2>
      <p style={bodyTextStyle}>
        AI가 빠르게 정리하더라도 최종 책임은 사람에게 있습니다. 안전한 활용은 &ldquo;AI를 덜 쓰자&rdquo;가 아니라{' '}
        <strong>&ldquo;검토 가능한 흐름으로 쓰자&rdquo;</strong>입니다.
      </p>
      <ol style={{ ...bodyTextStyle, marginBottom: '32px', paddingLeft: '22px' }}>
        <li>
          <strong>개인정보</strong> — 학생 이름·연락처·민감정보는 입력하지 않기
        </li>
        <li>
          <strong>익명화</strong> — 민감 사안은 가명·일반화된 상황으로 입력
        </li>
        <li>
          <strong>추측 금지</strong> — 없는 정보는 &ldquo;확인 필요&rdquo;로 표시하도록 요청
        </li>
        <li>
          <strong>최종 확인</strong> — 날짜·장소·금액·법적 문구는 담당자 검토
        </li>
        <li>
          <strong>책임성</strong> — AI는 초안 작성자·1차 정리자, 최종 판단은 학교
        </li>
      </ol>

      <h2 id="정리" style={h2Style}>
        정리 — AI 업무경감 4단계
      </h2>
      <p style={bodyTextStyle}>
        프롬프트 실습에서 업무 자동화 설계까지 연결합니다. AI는 교사의 일을 없애는 것이 아니라, 반복 업무를 검토
        가능한 구조로 바꾸게 합니다.
      </p>
      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <ol style={{ margin: 0, paddingLeft: '20px', lineHeight: 1.9, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
          <li>
            <strong>문서 만들기</strong> — 역할·목적·대상·정보·문체·형식
          </li>
          <li>
            <strong>형식 변환</strong> — 가정통신문 → 문자·멘트·체크리스트
          </li>
          <li>
            <strong>문서 읽기</strong> — 이수증·공문·회의록에서 필요한 정보 추출
          </li>
          <li>
            <strong>흐름 설계</strong> — 입력·저장·추출·화면·검토까지 설계
          </li>
        </ol>
      </div>
    </div>
  );
};

export default EwhaGeumranMiddleSchoolAITraining2026;
